/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */

const adobeTrack = (eventName) => {
  if (window._satellite) {
    try {
      console.log(`Tracking ${eventName}`, window.digitalDataLayer);
      window._satellite.track(eventName);
    } catch (error) {
      console.warn(`could not adobe track ${eventName}:`, error);
    }
  } else {
    console.warn(`could not adobe track ${eventName}, window._satellite not present.`);
  }
};

const adobeSetVar = (name, value) => {
  if (window._satellite) {
    try {
      console.log(`SetVar ${name} to ${value}`);
      window._satellite.setVar(name, value);
    } catch (error) {
      console.warn(`could not set adobe var ${name}:`, value);
    }
  } else {
    console.warn(`could not set adobe var ${name} to ${value}, window._satellite not present.`);
  }
};

export {
  adobeTrack,
  adobeSetVar,
};
